export default class QRCodeImage {
  constructor (data) {
    data = data || {}

    this.base64 = data?.base64
    this.mimeType = data?.mimeType
  }

  getImage () {
    return this.mimeType && this.base64
      ? `data:${this.mimeType};base64,${this.base64}`
      : null
  }
}
